import { getDeviceLanguage } from "@/apps/credit-line/helpers/translations.helper";

export const getPrivacyPolicyUrl = async (): Promise<string> => {
  return `https://www.payjoy.com/privacy-policy?locale=${await getDeviceLanguage()}`;
};
